module.exports = __webpack_public_path__ + "img/back.4fae042d.png";